module.exports = __webpack_public_path__ + "static/media/cup.3265bbe0.png";